<template>
  <div :class="$style.rowSpacing">
    <fieldset>
      <div :class="$style.flexRow">
        <CheckboxWithLabel
          :label="sudoLabel"
          name="sudo"
          :tooltip="{
            kbLink: sudoKbLink,
            text: $options.tooltip.sudo.text,
          }"
          :value="sudoValue"
          @change="handleSudoChange"
        />
      </div>
    </fieldset>
    <fieldset
      :class="[passwordlessSudoClassName, $style.revealedRow]"
    >
      <div :class="$style.flexRow">
        <CheckboxWithLabel
          :label="passwordlessSudoLabel"
          name="passwordless_sudo"
          :tooltip="{
            text: $options.tooltip.passwordless_sudo.text,
          }"
          :value="passwordlessSudoValue"
          @change="handleValueChange"
        />
      </div>
    </fieldset>
  </div>
</template>
<script>
import { StoreModelMap, SudoConsts } from 'client/util/Constants';

import { mapActions, mapState } from 'vuex';
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';
import CheckboxWithLabel from 'client/components/FormValidation/CheckboxWithLabel.vue';
import ItemType from 'client/util/Constants/ItemType';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';

const { DeviceItemType } = ItemType;
const deviceItem = new DeviceItemType();

export default {
  name: 'AdminSudoInput',

  components: {
    CheckboxWithLabel,
  },

  mixins: [
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
  ],

  data() {
    return {
      deviceItem,
      passwordlessSudoLabel: `Global ${SudoConsts.passwordless}`,
      sudoKbLink: KbArticleUrls.settingAdministratorSudoPermission,
      sudoLabel: `Enable users as Global ${SudoConsts.sudo} on all ${deviceItem.labelPlural} associated
          through ${deviceItem.label} groups`,
    };
  },

  tooltip: {
    sudo: {
      text: `When checked, all users in this group will be given ${SudoConsts.sudo} permissions on all ${deviceItem.labelPlural} they are bound to through this group. When unchecked, permissions can be managed from the ${deviceItem.label} groups tab or on an individual user/${deviceItem.label} basis.`,
    },
    passwordless_sudo: {
      text: `${SudoConsts.passwordless} is recommended for service accounts only (applicable to Linux ${deviceItem.labelPlural}).`,
    },
  },

  computed: {
    passwordlessSudoClassName() {
      return [
        this.$style.passwordlessSudo,
        this.sudoEnabled ? this.$style.passwordlessSudoVisible : null,
      ];
    },
    passwordlessSudoValue() {
      return (this.passwordLessSudoEnabled === true);
    },
    sudoValue() {
      return (this.sudoEnabled === true);
    },
  },

  beforeCreate() {
    this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options);
    const userGroupModel = StoreModelMap[this.$options.propsData.parentType];

    this.$options.computed = {
      ...this.$options.computed,
      ...mapState(userGroupModel, {
        passwordLessSudoEnabled: state => state.item.passwordLessSudoEnabled,
        sudoEnabled: state => state.item.sudoEnabled,
      }),
    };

    this.methods = {
      ...mapActions(userGroupModel, ['setItemField']),
      ...this.methods,
    };
  },

  methods: {
    handleSudoChange(checked) {
      if (checked) {
        this.setItemField({ key: 'sudoEnabled', value: true });
      } else {
        this.setItemField({ key: 'passwordLessSudoEnabled', value: false });
        this.setItemField({ key: 'sudoEnabled', value: false });
      }
    },

    handleValueChange(checked) {
      this.setItemField({ key: 'passwordLessSudoEnabled', value: checked });
    },
  },
};
</script>
<style module>
@import '../../css/flex.css';
@import '../../components/FormValidation/css/formFields.css';

@value (slideUpDownTransition) from '~css/transitions.css';

.flexRow .flexColumn input[type="checkbox"] {
  margin-top: 3px;
}

.flexRow label.label.label {
  margin: 0 0 5px 0;
}

.revealedRow.revealedRow {
  margin-left: var(--jc-spacer-medium);
}

.icon {
  font-size: var(--jcBodyLarge);
}

.passwordlessSudo {
  margin-left: 1rem;
  max-height: 0;
  overflow: hidden;
  transition: slideUpDownTransition;
}

.passwordlessSudoVisible {
  max-height: 3rem;
}

.flexRow {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
}

.flexColumn {
  display: flex;
  flex: 1;
  flex-basis: 100%;
  flex-direction: column;
}

.smallColumn {
  flex: 0 0 12px;
}

.gutter {
  margin-right: 12px;
}
</style>
